export default "__VITE_ASSET__8617420d__"